/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
mutation UpdateGeneralTimeRegistrationSettingsMutation(
  $input: UpdateGeneralTimeRegistrationSettingsInput!
) {
  updateGeneralTimeRegistrationSettings(input: $input) {
    timeRegistrationSettings {
      granularity
      allowDoneTasks
      allowProjects
      allowInternalTime
      allowBillableSplit
      allowRoles
      allowExceedingEstimate
      allowOutsideProjectDates
      allowOutsideTaskDates
      requireTaskAssignment
      requireNote
      strictMode
      id
    }
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input",
            "type": "UpdateGeneralTimeRegistrationSettingsInput!"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "granularity",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowDoneTasks",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowProjects",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowInternalTime",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowBillableSplit",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowRoles",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowExceedingEstimate",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowOutsideProjectDates",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowOutsideTaskDates",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requireTaskAssignment",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requireNote",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "strictMode",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateGeneralTimeRegistrationSettingsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateGeneralTimeRegistrationSettingsPayload",
                    "kind": "LinkedField",
                    "name": "updateGeneralTimeRegistrationSettings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegistrationSettingsType",
                            "kind": "LinkedField",
                            "name": "timeRegistrationSettings",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateGeneralTimeRegistrationSettingsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateGeneralTimeRegistrationSettingsPayload",
                    "kind": "LinkedField",
                    "name": "updateGeneralTimeRegistrationSettings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegistrationSettingsType",
                            "kind": "LinkedField",
                            "name": "timeRegistrationSettings",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "UpdateGeneralTimeRegistrationSettingsMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateGeneralTimeRegistrationSettingsMutation(\n  $input: UpdateGeneralTimeRegistrationSettingsInput!\n) {\n  updateGeneralTimeRegistrationSettings(input: $input) {\n    timeRegistrationSettings {\n      granularity\n      allowDoneTasks\n      allowProjects\n      allowInternalTime\n      allowBillableSplit\n      allowRoles\n      allowExceedingEstimate\n      allowOutsideProjectDates\n      allowOutsideTaskDates\n      requireTaskAssignment\n      requireNote\n      strictMode\n      id\n    }\n  }\n}\n"
        }
    };
})();
node.hash = '4668f5b26a6c2c980cde3dd4d1fd2b42';
export default node;
